<div id="layout-wrapper">
  <!--topbar-->
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="/" class="logo">
            <span class="logo-box">
              <img src="assets/imgs/logo_w.png" alt="logo" height="30" />
            </span>
          </a>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          id="vertical-menu-btn"
          (click)="toggleMobileMenu($event)"
          (settingsButtonClicked)="onSettingsButtonClicked()"
          (mobileMenuButtonClicked)="onToggleMobileMenu()"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <!--알람 내역-->
        <!-- <div class="dropdown d-inline-block" ngbDropdown>
          <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown" ngbDropdownToggle>
            <i class="bx bx-bell bx-tada"></i>
            <span class="badge badge-danger badge-pill">3</span>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0" aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
            <div class="p-3">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-0">알람</h6>
                </div>
                <div class="col-auto">
                  <a href="javascript: void(0);" class="small">전체 삭제</a>
                </div>
              </div>
            </div>
            <perfect-scrollbar style="position: relative; height: 230px" [config]="configData">
              <a href="" class="text-reset notification-item">
                <div class="media">
                  <div class="media-body">
                    <h6 class="mt-0 mb-1">알람 제목</h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">알람 내역</p>
                      <p class="mb-0">
                        {{ ' 2202 / 02 / 08' | date: 'yyyy-MM-dd' }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </perfect-scrollbar>
          </div>
        </div> -->
        <!-- 전체푸시 전송 -->
        <!-- <button class="btn header-item font-size-14 d-flex align-items-center" (click)="allPush()">전체푸시전송</button> -->
        <!-- 비밀번호 변경 -->
        <button class="btn header-item font-size-14 d-flex align-items-center" (click)="pwChange()">비밀번호 변경</button>
        <button class="btn header-item font-size-14 d-flex align-items-center" (click)="logout()">
          <!-- <i class="bx bx-log-out mr-1"></i> -->
          로그아웃
        </button>
      </div>
    </div>
  </header>

  <ng-template #contentTemplate>
    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <!-- Left Menu Start -->

      <ul class="metismenu list-unstyled" *ngIf="menu">
        <li *ngFor="let list of menu">
          <a *ngIf="!list.subItems || list.subItems?.length == 0" routerLink="{{ list.link }}">
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span>
          </a>
          <a *ngIf="list.subItems && list.subItems?.length > 0" class="has-arrow" href="javascript: void(0);" (click)="open(list, menu)">
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span>
          </a>
          <ul *ngIf="list.subItems && list.subItems?.length > 0" class="sub-menu" aria-expanded="true" [ngClass]="{ 'side-close': !list.openSwitch }">
            <li *ngFor="let item of list.subItems">
              <a [routerLink]="item.link" class="side-nav-link-ref" routerLinkActive="active">
                <span>{{ item.label }}</span>
              </a>
            </li>
          </ul>
        </li>
        <!-- end Layout menu -->
      </ul>
    </div>
  </ng-template>
  <!-- Sidebar -->

  <div class="vertical-menu">
    <perfect-scrollbar [config]="configData">
      <div *ngIf="!isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
      <div *ngIf="isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
    </perfect-scrollbar>
  </div>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
